import { render, staticRenderFns } from "./ReviewComponents.vue?vue&type=template&id=44733134&"
import script from "./ReviewComponents.vue?vue&type=script&lang=js&"
export * from "./ReviewComponents.vue?vue&type=script&lang=js&"
import style0 from "./ReviewComponents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports